var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "work-in-progress",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M19.214,2A12.214,12.214,0,1,0,31.429,14.214,12.214,12.214,0,0,0,19.214,2Zm0,4.75a1.357,1.357,0,0,1,1.357,1.357v5.455l2.884,2.307a1.357,1.357,0,0,1-1.7,2.12l-3.393-2.714a1.357,1.357,0,0,1-.509-1.06V8.107A1.357,1.357,0,0,1,19.214,6.75Z",
    transform: "translate(1.786)",
    fill: "#4397d2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M7.429,22a5.429,5.429,0,1,0,0,10.857H34.571a5.429,5.429,0,1,0,0-10.857ZM6.071,27.429a1.357,1.357,0,0,1,1.357-1.357h8.143a1.357,1.357,0,1,1,0,2.714H7.429A1.357,1.357,0,0,1,6.071,27.429Z",
    transform: "translate(0 7.143)",
    fill: "#4397d2",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgress);
export default __webpack_public_path__ + "static/media/work-in-progress.67e01bc1a99d89b2ca5b963ecb39b539.svg";
export { ForwardRef as ReactComponent };